/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


export const prepareApiRequestBody = (data: any): string => {

    return JSON.stringify(data);

};


export default prepareApiRequestBody;
